import React from 'react';
import { css } from '@linaria/core';
import { theme } from '@terveystalo/design-system-theme';
import { Text } from '../../atoms';
import { classnames } from '../../utils';
export const TextFieldMessage = ({ children, id, color }) => {
    return (React.createElement(Text, { as: "span", id: id, size: "m", color: color, "aria-live": "polite", className: classnames(css `
          text-align: left;
        `, 
        // For some reason babel in Linaria doesn't like React.Children.count() here,
        // boolean check should be enough for this case though
        Boolean(children) &&
            css `
            margin-top: ${theme.spacing['0_5']};
          `) }, children));
};


import "../../../css/molecules/TextField/Message.css";
